// User settings — persisted in localStorage. Pure utility, no framework deps.
//
// Three boolean toggles for now:
//   - stats: whether gameplay stats are recorded (default ON)
//   - sfx:   whether sound effects play           (default ON)
//   - music: whether the music track plays        (default OFF)
//
// Sfx and music are wired in the UI but have no audio implementation yet; the
// stats flag is consumed by data/stats.js to short-circuit recording.

import { getItem, setItem } from './storage.js';

const KEY_STATS = 'minesweeper_settings_stats';
const KEY_SFX   = 'minesweeper_settings_sfx';
const KEY_MUSIC = 'minesweeper_settings_music';

const DEFAULTS = { stats: true, sfx: true, music: true };

function readBool( key, fallback )
{
    const raw = getItem( key );
    if ( raw === null ) return fallback;
    return raw === '1' || raw === 'true';
}

function writeBool( key, value )
{
    setItem( key, value ? '1' : '0' );
}

export function getSettings()
{
    return {
        stats: readBool( KEY_STATS, DEFAULTS.stats ),
        sfx:   readBool( KEY_SFX,   DEFAULTS.sfx ),
        music: readBool( KEY_MUSIC, DEFAULTS.music ),
    };
}

export function setSetting( key, value )
{
    if ( key === 'stats' ) writeBool( KEY_STATS, !!value );
    else if ( key === 'sfx' )   writeBool( KEY_SFX,   !!value );
    else if ( key === 'music' ) writeBool( KEY_MUSIC, !!value );
}

export function isStatsEnabled()
{
    return readBool( KEY_STATS, DEFAULTS.stats );
}
